// Constantes liées aux variants de cartes

// Libellés longs (affichage complet)
export const LABELS = {
  normal: "Normale", reverse: "Reverse", holo: "Holo", cosmos: "Cosmos", rgb: "RGB",
  firstEdition: "1re Édition", wPromo: "Promo",
};

// Ordre d'affichage canonique des variants (badges + modal).
// « cosmos » (2026-09-26) : holo à motif Cosmos, variante à part entière
// (distincte de la holo classique, ex. Évoli 30th-116). Doit rester
// synchronisé avec VARIANT_ORDER côté backend (server.py).
export const VARIANT_ORDER = ["normal", "firstEdition", "holo", "cosmos", "rgb", "reverse", "wPromo"];

// Raretés (FR + EN) qui, en séries modernes, existent en Normale + Reverse.
// Sert UNIQUEMENT à compléter quand TCGdex ne renseigne QUE 'normal'
// (fréquent sur les anciens blocs XY / SM / BW mal renseignés).
export const REVERSE_RARITIES = new Set([
  "Common", "Uncommon", "Rare", "Rare Holo",
  "Commune", "Peu Commune", "Rare", "Rare Holo",
]);

// Raretés exclusives à Pokémon TCG Pocket (jeu mobile, système
// diamant/étoile/couronne) — vérifié en direct sur TCGdex (/fr/rarities +
// échantillon de cartes du set A1) : aucune de ces raretés n'existe dans
// le TCG physique. Sert à exclure TCG Pocket de la Vue par rareté sans
// toucher aux autres écrans (Explorer les cartes doit pouvoir les garder).
export const TCGP_ONLY_RARITIES = new Set([
  "Un Diamant", "Deux Diamants", "Trois Diamants", "Quatre Diamants",
  "Une Étoile", "Deux Étoiles", "Trois Étoiles",
  "Un Chromatique", "Deux Chromatiques",
  "Couronne",
]);

// Échelle d'état (grade Cardmarket), du meilleur au pire — doit rester
// synchronisée avec CONDITION_GRADES côté backend (server.py).
export const CONDITION_GRADES = ["Mint", "Near Mint", "Excellent", "Good", "Light Played", "Played", "Poor"];
export const DEFAULT_CONDITION = "Near Mint";
// Abréviations pour la petite tuile d'état sur les cartes de la grille.
export const CONDITION_ABBR = {
  "Mint": "M", "Near Mint": "NM", "Excellent": "EX", "Good": "GD",
  "Light Played": "LP", "Played": "PL", "Poor": "PO",
};

// Badges courts affichés sur les cartes (grille)
export const VARIANT_BADGE = {
  normal:       { label: "N",  title: "Normale" },
  reverse:      { label: "R",  title: "Reverse" },
  holo:         { label: "H",  title: "Holo" },
  cosmos:       { label: "C",  title: "Cosmos" },
  rgb:          { label: "RGB", title: "RGB" },
  firstEdition: { label: "1E", title: "1re Édition" },
  wPromo:       { label: "P",  title: "Promo" },
  stamp:        { label: "S",  title: "Tampon" },
};
